import {HttpBackend, HttpEvent, HttpRequest, HttpResponse} from "@angular/common/http";
import {importProvidersFrom, inject} from "@angular/core";
import {filter, map, Observable} from "rxjs";
import {parse} from "yaml";
import {TranslateLoader, TranslateModule, TranslateModuleConfig} from "@ngx-translate/core";

class TranslateYamlHttpLoader implements TranslateLoader {
    private path: string = '/assets/i18n/';
    private httpBackend = inject(HttpBackend);

    // https://github.com/ngx-translate/core/issues/1317 Circular DI
    getTranslation(lang: string): Observable<Record<string, any>> {
        const httpRequest = new HttpRequest('GET', `${this.path}${lang}.yaml`, {responseType: 'text'});
        return this.httpBackend.handle(httpRequest).pipe(
            filter((event: HttpEvent<any>): event is HttpResponse<any> => event instanceof HttpResponse),
            map((httpResponse: HttpResponse<any>) => parse(httpResponse.body) as Record<string, any>)
        );
    }

}

const config: TranslateModuleConfig = {
    fallbackLang: 'pt-BR',
    loader: {
        provide: TranslateLoader,
        useFactory: (httpBackend: HttpBackend) => new TranslateYamlHttpLoader(),
        deps: [HttpBackend],
    },
};


export function provideTranslation() {
    return importProvidersFrom([TranslateModule.forRoot(config)]);
}
